








































import { Component, Mixins } from "vue-property-decorator";
import { ReceptionComment } from "../../../domain/workflow/reception";
import { DialogMixin } from "../../system/mixins";
import { default as ConflictCommentEditor, instanceOfIConflictCommentEditor } from "../editors/controls/ConflictCommentEditor.vue";

@Component({
  components: {
    ConflictCommentEditor,
  }
})
export default class ConflictCommentComparedDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      isConfirmed: false,
      title: "",
      editingComment: "",
      label: "",
      latestReceptionComment: null,
      isEditOnly: false,
      isDeleted: false,
    };
  }
  isConfirmed: boolean;
  title: string;
  editingComment: string;
  label: string;
  latestReceptionComment: ReceptionComment;
  isEditOnly: boolean;
  isDeleted: boolean;

  async show(title: string, label: string, editingComment: string, latestReceptionComment: ReceptionComment, isEditOnly: boolean = false): Promise<string> {
    return this.showModal(async () => {
      this.isConfirmed = false;
      this.title = title;
      this.label = label;
      this.editingComment = editingComment
        ? editingComment
        : "";
      this.latestReceptionComment = latestReceptionComment;
      this.isDeleted = latestReceptionComment.deleted;
      this.isEditOnly = isEditOnly;
      await this.$nextTick();
      if (instanceOfIConflictCommentEditor(this.$refs.commentEditor)) {
        this.$refs.commentEditor.focus();
        this.$refs.commentEditor.setSelectionRange(this.editingComment.length, this.editingComment.length);
      }
      await this.waitHidden(true);
      return this.isConfirmed
        ? this.editingComment
        : undefined;
    });
  }

  confirm(): void {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  close(): void {
    this.isVisible = false;
  }
}
